import { FunctionComponent, useCallback, useEffect, useMemo, useState } from "react";
import frame0 from "../../images/jump-scare/0-min.png";
import frame1 from "../../images/jump-scare/1-min.png";
import frame2 from "../../images/jump-scare/2-min.png";
import frame3 from "../../images/jump-scare/3-min.png";
import frame4 from "../../images/jump-scare/4-min.png";
import frame5 from "../../images/jump-scare/5-min.png";
import frame6 from "../../images/jump-scare/6-min.png";
import frame7 from "../../images/jump-scare/7-min.png";
import frame8 from "../../images/jump-scare/8-min.png";
import frame9 from "../../images/jump-scare/9-min.png";
import frame10 from "../../images/jump-scare/10-min.png";
import frame11 from "../../images/jump-scare/11.png";
import gif from "../../images/jump-scare/jump-scare.gif";
import audioSrc from "./SnPK_10s.mp3";
import { ScareReason } from "./Maidchan";
import { Get, Post } from "../../utils/api";

interface IProps {
	scare: ScareReason | false;
	lastBah?: string | null;
	endScare: () => void;
}

const imageSrc = [
	frame0, frame1, frame2, frame3, frame4, frame5, frame6, frame7, frame8, frame9, frame10, frame11
];

export let scareReady = false;

const notReadyFrame = -2;
const startingFrame = -1;

const MaidchanJumpScare: FunctionComponent<IProps> = (props) => {
	const { scare: triggerScare, lastBah: lastBahProp, endScare: endScareTrigger } = props;

	const [ready, setReady] = useState(false);
	const [frame, setFrame] = useState(notReadyFrame);
	const [lastBah, setLastBah] = useState(lastBahProp);
	const [scare, setScare] = useState(false);

	useEffect(() => {
		setLastBah(lastBahProp);
	}, [lastBahProp]);
	
	const endScare = useCallback(() => {
		setScare(false);
		endScareTrigger();
	}, [endScareTrigger]);

	useEffect(() => {
		if (!triggerScare) { return; }
		if (!scareReady) {
			endScare();
			return;
		}

		if (triggerScare === ScareReason.Random) {
			// console.log("random scare");
			// check last time for re-trigger
			const oneYearAgo = new Date();
			oneYearAgo.setHours(oneYearAgo.getHours() - 365 * 24);
			if (!lastBah || new Date(lastBah) < oneYearAgo) {
				const random = Math.random();
				// console.log(`last scare ${lastBah} ${random}`)
				if (random > 0.5) {
					Get<void>("/chat/notifyBah");
					setScare(true);
					setLastBah(new Date().toISOString());
					return;
				}
			}

			// console.log(`last scare ${lastBah}`)
			endScare();
			return;
		}

		// console.log("click scare");
		setScare(true);
	}, [endScare, triggerScare]);

	useEffect(() => {
		if (!scare) { return; }
		setFrame(startingFrame);
	}, [scare]);

	const jumpScareContainerStyle: React.CSSProperties = useMemo(() => {
		if (!scare || !ready || frame < 0) {
			return {
				pointerEvents: "none"
			};
		}
		return {};
	}, [frame, ready, scare]);

	const jumpScareStyle = useCallback((f: number) => {
		if (scare && f === frame) {
			const style: React.CSSProperties = { display: "block" };
			return style;
		}
		return { opacity: 0 };
	}, [frame, scare]);

	useEffect(() => {
		if (!ready) { endScare(); }
		if (!ready || !scare || (frame < startingFrame || frame > 11)) { return; }
		if (frame === 0) {
			console.log("bah");
			const audio = document.getElementById("mcJumpAudio") as HTMLAudioElement;
			audio.play();
		}
		let timeout: any = null;
		if (frame === startingFrame) {
			const delay = (Math.floor(Math.random() * 4) + 2) * 1000;
			timeout = setTimeout(() => {
				setFrame(0);
			}, delay);
			return; 
		}
		if (frame === 11) { 
			timeout = setTimeout(() => {
				endScare();
				setFrame(startingFrame);
			}, 500);
			return; 
		}
		timeout = setTimeout(() => { setFrame(x => Math.min(x + 1, 11)); }, 50);
		return () => { if (timeout) { clearTimeout(timeout); } };
	}, [endScare, frame, ready, scare]);

	const setImages = useCallback(() => {
		for (let i = 0; i < 12; i++) {
			const image = document.getElementById(`mcJump${i}`);
			if (!image) { continue; }
			image.style.backgroundImage = "url('" + imageSrc[i] + "')";
		}
		const image = document.getElementById(`mcJumpGif`);
		if (!image) { return; }
		// image.style.backgroundImage = "url('" + gif + "')";
		const audio = document.getElementById("mcJumpAudio") as HTMLAudioElement;
		if (!audio) { return; }
		audio.src = audioSrc;

		setReady(true);
		scareReady = true;
	}, []);

	useEffect(() => {
		const timeout = setTimeout(() => { setImages(); }, 5000);
		return () => { clearTimeout(timeout); };
	}, [setImages]);

	return <div id="mcJump" className={`maidChanJump`} style={jumpScareContainerStyle}>
		<div id="mcJump0" style={jumpScareStyle(0)} />
		<div id="mcJump1" style={jumpScareStyle(1)} />
		<div id="mcJump2" style={jumpScareStyle(2)} />
		<div id="mcJump3" style={jumpScareStyle(3)} />
		<div id="mcJump4" style={jumpScareStyle(4)} />
		<div id="mcJump5" style={jumpScareStyle(5)} />
		<div id="mcJump6" style={jumpScareStyle(6)} />
		<div id="mcJump7" style={jumpScareStyle(7)} />
		<div id="mcJump8" style={jumpScareStyle(8)} />
		<div id="mcJump9" style={jumpScareStyle(9)} />
		<div id="mcJump10" style={jumpScareStyle(10)} />
		<div id="mcJump11" style={jumpScareStyle(11)} />
		<div id="mcJumpGif" style={{}} />
		<audio id="mcJumpAudio" autoPlay={false} />
	</div>;
}

export default MaidchanJumpScare;